<div class="page_wrapper">
    <app-header-new></app-header-new>

    <div class="container wrapper-page header-fix position-relative display-contents">
        <div class="row">
            <div class="col-lg-12">
                <div class="card m-b-30">
                    <div class="card-body">

                        <div class="row pl-md-5 pl-0">
                            <div class="col-md-12 detail-tbl ">
                                <h1 class="pt-5">
                                    <p style="margin-bottom: 5px;">Member : {{pat_name}}</p>
                                </h1>
                                <h1 class="pt-5"> </h1>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="datatable2_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
        <div class="row">
            <div class="col-sm-12">
                <table id="datatable2" class="table dataTable no-footer" role="grid" aria-describedby="datatable2_info">
                    <thead align="center">
                        <tr *ngIf="org?.length > 0" role="row">
                            <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                aria-sort="ascending" aria-label="Name: activate to sort column descending"
                                style="width: 15%;">
                                Healthcare List
                            </th>
                            <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                aria-label="Position: activate to sort column ascending" style="width: 15%;">
                                Connection Status
                            </th>
                            <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                aria-label="Position: activate to sort column ascending" style="width: 15%;">

                            </th>
                            <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                aria-label="Position: activate to sort column ascending" style="width: 15%;">

                            </th>
                            <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                                aria-label="Position: activate to sort column ascending" style="width: 15%;">

                            </th>
                        </tr>
                    </thead>

                    <tbody *ngIf="org?.length > 0;else no_data_templ">
                        <tr align="center" *ngFor="let item of org; let i = index ">

                            <td>{{ item[0]["oname"]}}</td>
                            <td>
                                <div *ngIf="item[0].Checked === false">
                                    <h5 align="center">
                                        <button type="button" class="tabledit-delete-button btn btn-sm btn-primary"
                                            style="float: none; margin: 5px;" (click)="SendOTP(contact_no, confirmationModal,item[0].org_code )
                                            ">
                                            Connect
                                        </button>
                                    </h5>
                                </div>
                                <div *ngIf="item[0].Checked === true">
                                    <h6 align="center">
                                        Connected
                                    </h6>
                                </div>
                            </td>
                            <td *ngIf="enableform">
                            </td>
                            <td></td>
                            <td></td>
                        </tr>

                    </tbody>

                    <ng-template #no_data_templ>
                        <!-- <td></td> -->
                        <!-- <td></td> -->
                        <h5 class="mt-3 text-center mt-2"> NO RECORDS FOUND</h5>
                    </ng-template>
                </table>


            </div>

        </div>

    </div>


    <app-footer-new></app-footer-new>
</div>

<ng-template #confirmationModal let-modal>
    <!-- Modal content -->
    <div class="modal-body">
        <span class="close" (click)="modal.dismiss(false)">&times;</span>
        <div class="row center-mobile">
            <div class="col-md-4 m-l-60 m12">
                <i class="fa fa-mobile heartbeat" style="font-size: 75px; color: #3654dc; margin-left: 25px;"
                    aria-hidden="true"></i>
            </div>
            <div class="col-md-8 m-l-10 m12">
                <form [formGroup]="patientForm">
                    <p style="margin-bottom: 5px;">Enter OTP</p>
                    <input id="otp" type="password" class="form-control" formControlName="otp" maxLength="6" required
                        autocomplete="new-password" />
                    <div *ngIf="patientForm.get('otp').hasError('required')" class="invalid-feedback">
                        OTP is required
                    </div>
                    <div *ngIf="patientForm.get('otp').touched && wrongOTP" class="invalid-feedback">
                        OTP is invalid
                    </div>
                    <button type="submit" class="btn btn-primary btn-lg  w-50" (click)="validateOTP()">Submit
                    </button>
                </form>
            </div>
        </div>
    </div>
</ng-template>